import PATH from "constants/path";
import React from "react";
import { ButtonBanner, ChevronRightGreen } from "assets/svg";

const Banner = () => {
  return (
    <div className="banner position-relative container-fluid px-0">
      <div className="position-absolute z-index-3 bottom-0 start-50 translate-middle-x">
        <a href={PATH.COMMON + PATH.SIGNUP}>
          <ButtonBanner className="svg-button" />
        </a>
        <div className="text-center mt-2">
          <a className="py-1 fw-700 text-green sp-14" href={PATH.FIRST}>
            いつモニとは
            <span className="ms-2">
              <ChevronRightGreen />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Banner;
